import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../core/auth.service';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;

  showErrorMessage: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  submit(): void {
    if (!this.loginForm.valid) {
      return;
    }
    this.authService.login(this.loginForm.value.username, this.loginForm.value.password).subscribe(success => {
      if (success) {
        this.router.navigate(['/calendar']);
      } else {
        this.showErrorMessage = true;
      }
    }, error => {
      console.log(error);
      throwError(error);
      this.showErrorMessage = true;
    });


  }

}